import { BrandOverlayEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandOverlaySetEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandOverlaySetEventDTO.validationSchema(),
    BrandOverlayEntity
  );

  constructor(readonly data: RoomBrandOverlaySetEvent) {
    JsonSchemaValidator.assert(RoomBrandOverlaySetEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandOverlay"],
      properties: {
        roomId,
        brandOverlay: {
          instanceof: BrandOverlayEntity.name
        }
      }
    };
  }
}

interface RoomBrandOverlaySetEvent {
  roomId: RoomId;
  brandOverlay: BrandOverlayEntity;
}
